'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('award', {
    url: '/award/:clinicId/?username&email',
    templateUrl: '/views/award.html',
    controller: 'AwardCtrl',
    data: {
      hideNavigation: true,
    },
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set("Patients' Choice Awards - Opencare");
      },
      clinic: function($stateParams, ClinicService) {
        return ClinicService.getClinic($stateParams.clinicId);
      },
    },
  });
});

angular.module('ClinicApp').controller('AwardCtrl', function($scope, $state, $stateParams, $timeout, clinic, OCDomUtil, GrowlService) {
  $scope.clinic = clinic;

  // Clinic primary specialty is required.
  if (!$scope.clinic.primarySpecialty) {
    GrowlService.error('Not enough data to claim award of the clinic.');
    return $state.go('home', null, {
      location: 'replace',
    });
  }

  var redirectStep = null;

  if ($scope.clinic.awardData) {
    if ($scope.clinic.awardData.claimedAt && $scope.clinic.awardData.verifiedAt) {
      // If award is already claimed & verified redirect user to the award sharing step.
      redirectStep = 4;
    } else if ($scope.clinic.awardData.claimedAt) {
      // If award is already claimed redirect user to the digital award step.
      redirectStep = 3;
    }
  }

  if (redirectStep) {
    return $state.go('award-claim', {
      clinicId: $scope.clinic.id,
      step: redirectStep,
      username: $stateParams.username,
      email: $stateParams.email,
    }, {
      location: 'replace',
    });
  }

  // Give a time to hide navigation to detect correct offsets.
  $timeout(function() {
    OCDomUtil.stickyScroll('#ibox-award', 20);
  });

  $scope.scrollTo = function(elSelector) {
    OCDomUtil.scrollTo(elSelector);
  };

  $scope.startAwardClaiming = function() {
    var step = $scope.clinic.awardData && $scope.clinic.awardData.claimedAt ? 3 : 1;
    $state.go('award-claim', {
      clinicId: $scope.clinic.id,
      step: step,
      username: $stateParams.username,
      email: $stateParams.email,
    });
  };
});
